import type { oz } from '@weft/utils';
import { ContactInputSchema } from '../../primitives/contact-input-schema';
import { AccountSettingsInputSchema } from '../account-settings/account-settings-input-schema';
import { NewAccountSchema } from './new-account-schema';

export const AccountInputSchema = NewAccountSchema.extend({
  settings: AccountSettingsInputSchema,
  contact: ContactInputSchema,
}).partial().openapi('AccountInput');

export type AccountInput = oz.infer<typeof AccountInputSchema>;